




































import { Vue, Component } from 'vue-property-decorator';
import { mapState } from 'vuex';

import { objectIsEmpty } from '~/utils/common.js';

@Component({
  middleware: 'noauth',
  computed: {
    ...mapState('website', [
      'content',
    ]),
    ...mapState('lang', [
      'locale',
    ]),
  },
  head () {
    const self: any = this;
    const locale: string = self.$store.state.lang.locale;

    return {
      title: `${self.$t('website.termsTitle')} - On Piste`,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: `${self.$t('website.termsTitle')} - On Piste`,
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: 'https://www.onpiste.com/img/placeholders/OnPiste_Logo_FB.jpg',
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `https://www.onpiste.com/${locale === 'fr' ? '' : `${locale}/`}terms-and-conditions`,
        },
      ],
    };
  },
  async fetch () {
    const self: any = this;
    await self.$store.dispatch('website/getPage', {
      type: 'TAC',
      lang: self.$store.state.lang.locale,
    });
  },
})
export default class TermsAndConditions extends Vue {
  content: {content: string};
  locale: string;

  /* Computed skeleton handle */
  get contentIsEmpty () {
    return objectIsEmpty(this.content);
  }
}
